import React, { useState } from 'react';
import { IoCallOutline } from 'react-icons/io5';
import './WhatsAppPopup.css';

// Official WhatsApp SVG Icon (brand accurate)
const WhatsAppSVG = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="none">
    <path d="M24 4C12.95 4 4 12.95 4 24c0 3.64.97 7.06 2.65 10.03L4 44l10.23-2.62A19.87 19.87 0 0024 44c11.05 0 20-8.95 20-20S35.05 4 24 4z" fill="#25D366"/>
    <path d="M34.6 29.24c-.48-.24-2.85-1.41-3.3-1.57-.44-.16-.76-.24-1.08.24-.32.48-1.23 1.57-1.51 1.89-.28.32-.56.36-1.04.12-.48-.24-2.02-.74-3.84-2.36a14.4 14.4 0 01-2.66-3.3c-.28-.48-.03-.74.21-.98.22-.22.48-.56.72-.84.24-.28.32-.48.48-.8.16-.32.08-.6-.04-.84-.12-.24-1.08-2.61-1.48-3.57-.39-.94-.79-.81-1.08-.83-.28-.02-.6-.02-.92-.02s-.84.12-1.28.6c-.44.48-1.68 1.64-1.68 4.01s1.72 4.65 1.96 4.97c.24.32 3.38 5.17 8.2 7.25 1.15.5 2.05.8 2.75 1.02 1.15.37 2.2.32 3.03.19.92-.14 2.85-1.16 3.25-2.29.4-1.12.4-2.08.28-2.29-.12-.2-.44-.32-.92-.56z" fill="white"/>
  </svg>
);

const WhatsAppPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  const whatsappNumber = "919172455555"; // From AppContext.js footerPhone1
  const message = encodeURIComponent("Namaste! 🙏 I would like to enquire about GDR Jewellers silver jewellery collection.");
  const waUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <div className="wa-widget-container">
      {/* Chat Window */}
      {isOpen && (
        <div className="wa-chat-window">
          <div className="wa-chat-header">
            <div className="wa-admin-avatar">
              <WhatsAppSVG size={28} />
            </div>
            <div className="wa-admin-info">
              <h4>GDR Jewellers</h4>
              <span className="wa-status">🟢 Online — Typically replies instantly</span>
            </div>
            <button className="wa-close-btn" onClick={() => setIsOpen(false)}>×</button>
          </div>
          <div className="wa-chat-body">
            <div className="wa-chat-bubble">
              <p>Namaste! 🙏 Welcome to GDR Jewellers. How can we help you today with your silver jewellery enquiry?</p>
              <span className="wa-time">{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
            </div>
          </div>
          <div className="wa-chat-footer">
            <a href={waUrl} target="_blank" rel="noopener noreferrer" className="wa-chat-cta">
              <WhatsAppSVG size={20} />
              Start WhatsApp Chat
            </a>
          </div>
        </div>
      )}

      {/* Floating Action Button */}
      <button className="wa-float-btn" onClick={() => setIsOpen(!isOpen)} title="Contact GDR Jewellers" aria-label="Call or WhatsApp">
        <IoCallOutline size={30} />
        <span className="wa-pulse"></span>
      </button>
    </div>
  );
};

export default WhatsAppPopup;
